<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: 'App',
  created(){
    this.$store.dispatch('init');
  }
}
</script>

<style>
imp
html, body{
  height: 100%;
}
#app{
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue